import store from '../store'
class HalfYearGivingPeriodStrategy {
  type = 2 // 1 满减 2 满赠
  startDate = new Date(2019, 4, 10)
  endDate = new Date(2019, 6, 1)
  isLongTime = false

  matchProductIds = ['SHSHFC0002', 'SHSHFC0003']

  /**
   * 计算赠送的时间长度
   * @param productSerialId
   * @return {number}
   */
  calGivingPeriod(productSerialId) {
    if (this.matchProductIds.includes(productSerialId)) {
      return 1
    } else {
      return 0
    }
  }

  /**
   * 产品详情页显示的促销信息
   * @return {string}
   */
  givingInfo() {
    return '买一年赠送一个月服务时长（非续费）'
  }

  /**
   * 匹配函数， 检查当前产品id是否在活动期间内
   * @param productSerialId
   * @return {boolean}
   */
  matched(productSerialId) {
    let curComp = store.state.global.currentCompany
    // 续费不参与此活动 company.isRenewals = true 是续费客户
    if (curComp && curComp.isRenewals) {
      return false
    }
    let matched = this.matchProductIds.includes(productSerialId);
    let today = new Date()
    let inDateRange = today.getTime() > this.startDate.getTime() && today.getTime() < this.endDate.getTime()
    return matched && inDateRange
  }
}

class DoubleElevenGivingPeriodStrategy {
  type = 2 // 1 满减 2 满赠
  startDate = new Date(2019, 9, 21)
  endDate = new Date(2019, 10, 12)
  isLongTime = false

  matchProductIds1 = [
    'BJBJFC0002', 'GDSZFC0002', 'HNZZFC0002',
    'JSNJFC0002', 'JSSZFC0002', 'JSZJFC0038',
    'JSZJFC0059', 'SCCDFC0002', 'SHSHFC0002'
  ]
  matchProductIds2 = [
    'BJBJFC0003', 'GDSZFC0003', 'HNZZFC0003',
    'JSNJFC0003', 'JSSZFC0003', 'JSZJFC0003',
    'JSZJFC0039', 'SCCDFC0003'
  ]

  calGivingPeriod(productSerialId) {

  }

  calGivingMoney(productId) {
    if (this.matchProductIds1.includes(productId)) {
      return 200
    } else if (this.matchProductIds2.includes(productId)) {
      return 300
    } else {
      return 0
    }
  }

  givingInfo(productId) {
    if (this.matchProductIds1.includes(productId)) {
      return '买一年赠送服务费200'
    } else if (this.matchProductIds2.includes(productId)) {
      return '买一年赠送服务费300'
    } else {
      return 0
    }
  }

  matched(productSerialId) {
    let matched = this.matchProductIds1.includes(productSerialId) || this.matchProductIds2.includes(productSerialId);

    let today = new Date()
    let inDateRange = today.getTime() > this.startDate.getTime() && today.getTime() < this.endDate.getTime()
    return matched && inDateRange
  }
}

let SaleStrategy = {
  // 满减活动
  reduceStrategies: [
  ],
  // 满赠活动
  givingStrategies: [
    new HalfYearGivingPeriodStrategy()
  ],
  givingPeriodStrategy: new DoubleElevenGivingPeriodStrategy()
}

module.exports = SaleStrategy



// WEBPACK FOOTER //
// ./src/utils/saleActivity.js